import { configureStore } from '@reduxjs/toolkit'
import { rootReducer } from './reducers'
import { AppTypes } from './reducers/app.reducer'
import { isMobile } from './hooks/IsMobile'

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === 'development',
})

export type IStore = ReturnType<typeof rootReducer>

window.addEventListener('resize', () => {
  if (isMobile()) {
    store.dispatch({ type: AppTypes.EXPAND_MENU })
  }
})

if (store.getState().app.chatOpened === null) {
  if (isMobile('xl', true, 1537)) {
    store.dispatch({ type: AppTypes.CLOSE_CHAT })
  }
}
